import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {Icon} from '@components/common/base/icon'
import {SelectWithDropdown} from '@components/common/base/select-with-dropdown'
import {menuItemHeight} from '../constants'
import {DestinationStore, StoreContext, useStore} from './destination-store'
import {DestinationRet} from './types'

const TwMainContainer = tw.div`
  flex
  gap-8
  items-center
`

interface BaseProps {
  value?: DestinationRet
  allOption: boolean
}

export const DestinationBase = observer(({value, allOption}: BaseProps) => {
  const [state, store] = useStore()

  useEffect(() => {
    if (!value) {
      return
    }

    const {project, board, column} = value

    store.setInitValues(project, board, column)
  }, [value])

  const projectOptions = store.getProjectOptions(allOption)
  const boardOptions = store.getBoardOptions(allOption)
  const columnsOptions = store.getColumnsOptions([], allOption)

  const projTitleOrig = state.project?.title || ''
  const boardTitleOrig = state.board?.title || ''
  const columnTitleOrig = state.column?.title || ''

  const noAccessToProject = Util.isUUID(projTitleOrig)
  const noAccessToBoard = Util.isUUID(boardTitleOrig)
  const noAccessToColumn = Util.isUUID(columnTitleOrig)

  const isBoardsDisable =
    !state.project?.id || noAccessToProject || state.project?.id === 'all'
  const isColumnsDisable =
    !state.board?.id ||
    state.board?.id === 'all' ||
    !columnsOptions.length ||
    noAccessToBoard ||
    noAccessToColumn
  const lang = Lang.msg.movementTemplates

  const projTitle = noAccessToProject ? lang.noAccess : projTitleOrig

  const boardTitle = noAccessToBoard ? lang.noAccess : boardTitleOrig

  const columnTitle = noAccessToColumn ? lang.noAccess : columnTitleOrig

  return (
    <TwMainContainer>
      <div className="max-w-170 w-full">
        <SelectWithDropdown
          options={projectOptions}
          value={projTitle}
          placeholder={lang.destinationProjectPlaceholder}
          size={menuItemHeight}
          width={'min-w-202'}
        />
      </div>

      <>
        <Icon icon="IconChevronRight" />

        <SelectWithDropdown
          options={boardOptions}
          value={boardTitle}
          placeholder={lang.destinationBoardPlaceholder}
          size={menuItemHeight}
          disabled={isBoardsDisable}
          width={'min-w-202'}
        />
      </>

      <>
        <Icon icon="IconChevronRight" />

        <SelectWithDropdown
          options={columnsOptions}
          value={columnTitle}
          placeholder={lang.destinationColumnPlaceholder}
          size={menuItemHeight}
          disabled={isColumnsDisable}
          width={'min-w-202'}
        />
      </>
    </TwMainContainer>
  )
})

export interface DestinationProps {
  onChange: (props: DestinationRet) => void
  value?: DestinationRet
  allOption?: boolean
}

export const Destination = observer((props: DestinationProps) => {
  const {onChange, value, allOption = false} = props
  const [store] = useState(() => new DestinationStore(onChange))

  return (
    <StoreContext.Provider value={store}>
      <DestinationBase value={value} allOption={allOption} />
    </StoreContext.Provider>
  )
})
